exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".delete__dialog__title[data-v-b4d75870]{white-space:normal;word-break:break-word}\n", ""]);
